"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRoutesCacheInstance = void 0;
const enums_1 = require("@aurora/shared-types/pages/enums");
const Routes_1 = __importDefault(require("@aurora/shared-utils/helpers/urls/NextRoutes/Routes"));
const log_1 = require("@aurora/shared-utils/log");
const endUserRoutes_1 = require("./endUserRoutes");
const log = (0, log_1.getLog)(module);
/**
 * An in memory cache for routes, to prevent building them on each request.
 */
class RoutesCache {
    /**
     * Builds routes given a Tenant and PageResources.
     * @param tenant The tenant to build routes for.
     * @param pages The pages to build routes for.
     */
    buildRoutes(tenant, pages) {
        var _a;
        if (!pages.localOverride && this.cachedRoutes && pages.lastModified === this.cachedTimestamp) {
            return this.cachedRoutes;
        }
        const { basePath } = tenant;
        const routes = new Routes_1.default(basePath);
        if (((_a = pages.pages) === null || _a === void 0 ? void 0 : _a.length) > 0) {
            pages.pages.forEach(({ page }) => {
                try {
                    const { id, urlPath } = page;
                    const path = enums_1.EndUserPages[id] == null ? endUserRoutes_1.pageToPathMap[enums_1.EndUserPages.CustomPage] : endUserRoutes_1.pageToPathMap[id];
                    routes.add(id, urlPath, path);
                }
                catch (error) {
                    log.error(error, 'Unable to add page: %O', page);
                }
            });
        }
        this.cachedRoutes = routes;
        this.cachedTimestamp = pages.lastModified;
        return this.cachedRoutes;
    }
}
exports.default = RoutesCache;
/**
 * Get a global instance of the cache.
 */
function getRoutesCacheInstance() {
    if (!global.routesCache) {
        global.routesCache = new RoutesCache();
    }
    return global.routesCache;
}
exports.getRoutesCacheInstance = getRoutesCacheInstance;
//# sourceMappingURL=RoutesCache.js.map